import styled from "styled-components";

// O modal da área comum tem fundo escuro (neutral.black) e altura limitada pela
// viewport: a tabela rola dentro dele, senão uma carteira grande empurra os
// botões para fora da tela.
export const TableWrapper = styled.div`
  max-height: 55vh;
  overflow: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 8px 10px;
    font-size: 14px;
    text-align: left;
    color: ${({ theme }) => theme.colors.neutral.white};
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.cinza800};
  }

  th {
    position: sticky;
    top: 0;
    background-color: ${({ theme }) => theme.colors.neutral.black};
    font-size: 13px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primary.orange};
  }

  /* Números alinhados à direita — cabeçalho junto com a célula, pela MESMA
     regra: alinhar o th por posição desalinharia a coluna "Cidade", que é texto. */
  [data-type="currency"],
  [data-type="number"] {
    text-align: right;
  }
`;

export const Empty = styled.span`
  color: ${({ theme }) => theme.colors.neutral.white};
  font-size: 14px;
`;
